import { PPInput, PPMultiSelect, PPTextField, PPToggle } from 'processor-plataform-ui';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MenuState } from '../../../../store/reducers/menuReducer';
import { UserState } from '../../../../store/reducers/userReducer';
import { PrefState } from '../../../../store/reducers/prefReducer';
import { RootState } from '../../../../store/index';
import LcLoading from '../../../Generic/LcLoading';
import moment from 'moment';
import LcIcon from '../../../Generic/LcIcon';
import LcIconLink from '../../../Generic/LcIconLink';
import LcDropDown from '../../../Generic/LcDropDown';
import Modal from '../../../Dialog/Modal';
import { Validate } from '../../../../models/Validate';
import './index.css';
import CustomerService from '../../../../services/CustomerService/CustomerService';
import WorkTeamService from '../../../../services/WorkTeamService/WorkTeamService';
import TextTools from '../../../../services/TextTools/TextTools';
import HeyHoUserService from '../../../../services/HeyHoUserService/HeyHoUserService';
import SolicitationService from '../../../../services/SolicitationService/SolicitationService';
import ServiceGroupService from '../../../../services/ServiceGroupService/ServiceGroupService';
import ServiceService from '../../../../services/ServiceService/ServiceService';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import AlertNotification, { AlertColor } from '../../../Dialog/AlertNotification';
import SolicitationAttendantService from "../../../../services/SolicitationAttendantService/SolicitationAttendantService";
import SideModal from '../../../Layout/SideModal/SideModal';
import LcInfiniteTable from '../../LcInfiniteTable';

interface Props {
    handleClearFilters: Function,
    currentFilter: any,
    handleFilters: Function,
    filterDefault: any
}

const locales = ['pt-br'];
type LocaleKey = (typeof locales)[number];

const AttendanceFilters: React.FC<Props> = (props) => {
    const widthGeral = "16rem";
    const [locale, setLocale] = useState<LocaleKey>('pt-br');
    if (moment.locale() !== locale) {
        moment.locale(locale);
    }

    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const user = useSelector<RootState, UserState>(state => state.user);
    const pref = useSelector<RootState, PrefState>(state => state.pref);
    const dispatch = useDispatch();

    const textTools = new TextTools();
    const customerService = new CustomerService(props);
    const workTeamService = new WorkTeamService(props);
    const userService = new HeyHoUserService(props);
    const solicitationService = new SolicitationService(props);
    const serviceGroupService = new ServiceGroupService(props);
    const serviceService = new ServiceService(props);
    const solicitationAttendantService = new SolicitationAttendantService(props);

    const [filter, setFilter] = useState<any>(props.currentFilter);
    const [nameFilter, setNameFilter] = useState<any>("");

    const [enableAttendentType, setEnableAttendentType] = useState<boolean>(false);
    const [profileList, setProfileList] = useState<any[]>([
        { label: 'Atendente', value: '1' },
        { label: 'Gestor', value: '2' },
    ]);
    const [customerList, setCustomerList] = useState<any[]>([]);
    const [teamList, setTeamList] = useState<any[]>([]);
    const [attendantList, setAttendantList] = useState<any[]>([]);
    const [statusList, setStatusList] = useState<any[]>([]);
    const [groupServiceList, setGroupServiceList] = useState<any[]>([]);
    const [serviceList, setServiceList] = useState<any[]>([]);
    const [requesterList, setRequesterList] = useState<any[]>([]);
    const [stateList, setStateList] = useState<any[]>([]);

    const [filtersList, setFiltersList] = useState<any>([]);

    const [customerLoading, setCustomerLoading] = useState<boolean>(false);
    const [teamLoading, setTeamLoading] = useState<boolean>(false);
    const [attendantLoading, setAttendantLoading] = useState<boolean>(false);
    const [groupServiceLoading, setGroupServiceLoading] = useState<boolean>(false);
    const [serviceLoading, setServiceLoading] = useState<boolean>(false);
    const [requesterLoading, setRequesterLoading] = useState<boolean>(false);
    const [loadingFilters, setLoadingFilters] = React.useState<boolean>(false);

    const [openNameFilter, setOpenNameFilter] = useState<boolean>(false);
    const [loadingSaveFilter, setLoadingSaveFilter] = useState<boolean>(false);
    const [validations, setValidations] = useState<Validate[]>([]);
    const [filterDefault, setFilterDefault] = useState<any>(props.filterDefault);
    const [filterSort, setFilterSort] = useState<{ size: number, term: string, column: string, direction: string }>(filterDefault);
    const [filterSelected, setFilterSelected] = useState<any>({});
    const [onNotification, setOnNotification] = useState<boolean>(false);
    const [messageNotifications, setMessageNotification] = useState<string>("");
    const [severityMessage, setSeverityMessage] = useState<AlertColor>("success");

    const filterColumns = [
        {
            field: "name",
            headerName: "Descrição",
            width: "88%",
            class: "name",
            renderCell: (row: any) => <span style={{ cursor: "pointer" }} onClick={() => applySelectedFilter(row)}>{row.name}</span>
        },
        {
            field: "",
            headerName: "",
            align: "right",
            overFlow: "visible",
            width: "12%",
            renderCell: (row: any) => <LcIconLink icon="ppi ppi-trash" onClick={() => deleteFilter(row.id)} tooltip={"Excluir filtro"} />
        },
    ];

    const validateRules = () => {
        var validationsChecks: Validate[] = [];

        if (!(nameFilter.length > 0)) {
            validationsChecks.push({
                name: 'name',
                validateMessage: 'Deve possuir um nome válido.',
                valid: false
            });
        }

        setValidations(validationsChecks);
        return validationsChecks.length === 0;
    }

    useEffect(() => {
        if (pref.dataLocal?.filterSelected) {
            getCustomers()
        }
    }, [pref.dataLocal?.filterSelected])


    useEffect(() => {
        setFilter({ ...props.currentFilter });
    }, [props.currentFilter]);

    useEffect(() => {
        getFilters();
    }, []);

    useEffect(() => {
        if (user) {
            setEnableAttendentTypeField();
            getCustomers();
            getTeams();
            getAttendants();
            getStatus();
            getGroupService();
            getService();
            getRequesters();
            getState();
        }
    }, [props.currentFilter]);

    useEffect(() => {
        getTeams();
        getAttendants();
        getGroupService();
        getService();
        getRequesters();
        getState();
        getStatus();
    }, [filter.customerId]);

    useEffect(() => {
        getTeams();
    }, [filter.attendantType]);

    useEffect(() => {
        getAttendants();
        getRequesters();
    }, [filter.idTeam]);

    useEffect(() => {
        getService();
    }, [filter.IdsGroupService]);

    useEffect(() => {
        setNameFilter((filterSelected && filterSelected.name) ? filterSelected.name : "");
    }, [filterSelected]);

    const onHandleChange = (event: any, currentFilterList: any[]) => {
        if (event.target) {
            const { name, value } = event.target;
            // let valueList = value.map(i => i.value) ?? [];

            // if (!textTools.compareArrays(valueList, currentFilterList)) {
            setFilter((prevState) => {
                return {
                    ...prevState,
                    [name]: value.map((x: any) => x.value)
                };
            });
            // }
        }
    }

    const onHandleChangeDate = (event: any) => {
        if (event.target) {
            const { name, value } = event.target;

            setFilter((prevState) => {
                return {
                    ...prevState,
                    [name]: value
                };
            });
        }
    }

    const onHandleChangeInput = (event: any) => {
        if (event) {
            const { checked, name } = event;

            setFilter((prevState) => {
                return {
                    ...prevState,
                    [name]: checked
                };
            });
        }
    }

    const refreshList = (list: any[], selected: any[], select?: boolean) => {
        let refresh = list.map(field => {
            let filter = (selected instanceof Array) ? selected.find(i => i === field.value) : selected === field.value;

            if (filter) {
                return {
                    ...field,
                    selected: (select) ? true : false
                }
            }
            else {
                return {
                    ...field,
                    selected: false
                }
            }
        })

        return refresh;
    }

    // const onSortChange = (sortData: any) => {
    //     const { sort, size } = sortData;

    //     setFilterSort({
    //         ...filterSort,
    //         column: sort.column,
    //         direction: sort.direction,
    //         size: size
    //     });
    // };

    const applyFilters = () => {
        dispatch({
            type: "PREF_UPDATE_MORE",
            payload: {
                "filterSelected": { ...filter },
                "datefilterSelected": ""
            }
        });

        Object.keys(filter).map((field) => {
            let field_ = field as string;

            if (field_ === "dataInicio" || field_ === "dataFinal") {
                if (filter[field_] === "") {
                    filter[field_] = "0";
                }
            }

            if (field_ === "attendantType") {
                if (filter[field_] === "" || filter[field_] === "0" || filter[field_].length === 0) {
                    filter[field_] = "1";
                }
            }

            if (filter[field_] instanceof Array && filter[field_].length === 0) {
                filter[field_].push("0");
            }
        });

        props.handleFilters(filter);
    }

    const clearFilters = () => {
        dispatch({
            type: "PREF_UPDATE_MORE",
            payload: {
                "filterSelected": props.filterDefault,
                "SolicitationListAtttedantType": "",
                "datefilterSelected": ""
            }
        });

        props.handleClearFilters();
        setFilterSelected(undefined);
        setFilter(props.filterDefault);
    }

    const handleCloseModal = () => {
        setOpenNameFilter(false);
        setValidations([]);
    }

    const getFilters = async () => {
        try {
            const solicitationAttendanteResponse = await solicitationAttendantService.SelectAttendantFilters(Number(user.id));
            const filteredAttendants = solicitationAttendanteResponse.data.filter((item: any) => item.origem === "atendente" || item.origem === null);
            setFiltersList(filteredAttendants);
        }
        catch (error) {
            console.warn(error);
        }
    }

    const handleSelectedFilter = (filter: any, nameFilter: string, type: string) => {
        if (type === "insert" || type === "update") {
            saveFilter(filter, nameFilter);
        }
        else if (type === "delete") {
            deleteFilter(filter.id);
        }
        else if (type === "select") {
            applySelectedFilter(filter);
        }
    }

    const [openModalFilter, setOpenModalFilter] = useState<boolean>(false);

    const applySelectedFilter = (_filter: any) => {
        const filterSelected = JSON.parse(_filter.json);
        dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "filterSelected", value: filterSelected } });
        setFilter(filterSelected);
        setFilterSelected(_filter);
        if (openModalFilter) setOpenModalFilter(false);
    }

    const saveFilter = async (filter: any, nameFilter: string) => {
        setLoadingFilters(true);

        try {
            let idUpdate = filtersList.find((element: any) => {
                return element.name === nameFilter;
            })

            let _filter: any = {
                IdUser: Number(user.id),
                Name: nameFilter,
                Json: JSON.stringify(filter),
                origem: "atendente"
            }

            if (idUpdate) {
                _filter = {
                    ..._filter,
                    id: idUpdate?.id
                }
            }

            await solicitationAttendantService.SaveFilter(_filter);
            getFilters();
        }
        catch (error) {
            console.warn(error);
        }

        setLoadingFilters(false);
    }

    const deleteFilter = async (filterId: number) => {
        setLoadingFilters(true);

        try {
            await solicitationAttendantService.DeleteAttendantFilter(filterId);
            getFilters();
        }
        catch (error) {
            console.warn(error);
        }

        setLoadingFilters(false);
    }

    const setEnableAttendentTypeField = async () => {
        try {
            const managerList = await workTeamService.GetUserManager(Number(user.id));
            setEnableAttendentType(managerList.data.length > 0);

            if (managerList.data.length === 0) {
                setFilter({
                    ...filter,
                    attendantType: 1
                });
            }

            const _profileList = profileList.map((item) => {
                if (filter.attendantType.includes(item.value)) {
                    return { ...item, selected: true };
                }

                return { ...item, selected: false };
            });

            setProfileList(_profileList);
        }
        catch (error) {
            console.error(error);
        }
    }

    const getCustomers = async () => {
        setCustomerLoading(true);

        try {
            let customerResponse = await customerService.GetByUserWorkTeamId(user.id, 0);
            let _customerList = textTools.mountDropList(customerResponse.data);
            _customerList = refreshList(_customerList, filter.customerId ?? [], true);
            setCustomerList(_customerList);
        }
        catch (e) {
            console.error(e);
        }

        setCustomerLoading(false);
    }

    const getTeams = async () => {
        setTeamLoading(true)

        try {
            const profile = (filter && filter.attendantType && filter.attendantType.length > 0) ? filter.attendantType : "1";
            const customer = (filter) ? filter.customerId : props.currentFilter.customerId;

            let concatenatedString = profile;

            if (Array.isArray(profile) && profile.length > 0) {
                concatenatedString = profile.join('_');
            }

            var customerValue = (customer.length > 0) ? customer : "0";

            let teamResponse = await workTeamService.GetWorkTeambyUserCustomerId(Number(user.id), customerValue, concatenatedString);

            let _teamList = textTools.mountDropList(teamResponse.data);
            _teamList = refreshList(_teamList, filter.idTeam ?? [], true);
            setTeamList(_teamList);
        }
        catch (e) {
            console.error(e);
        }

        setTeamLoading(false);
    }

    const getAttendants = async () => {
        setAttendantLoading(true)

        try {
            const workTeamId = (filter) ? filter.idTeam : props.currentFilter.idTeam;
            const customerIdList = (filter) ? filter.customerId : props.currentFilter.customerId;

            let concatenatedString = customerIdList;

            if (Array.isArray(customerIdList) && customerIdList.length > 0) {
                concatenatedString = customerIdList.join("_");
            }

            if (concatenatedString.length === 0) {
                concatenatedString = "0";
            }

            let concatenatedStringTeam = workTeamId;

            if (Array.isArray(workTeamId) && workTeamId.length > 0) {
                concatenatedStringTeam = workTeamId.join("_");
            }

            if (concatenatedStringTeam.length === 0) {
                concatenatedStringTeam = "0";
            }

            var response = await userService.GetUsersAttendantMulti(user.id, concatenatedStringTeam, concatenatedString);
            let _attendantList = textTools.mountDropList(response.data);
            _attendantList = refreshList(_attendantList, filter.attendantId ?? [], true);

            let finalOpt = [
                { label: "@Me", value: user.id ? user.id : 0 },
                { label: "Sem Atendente", value: "NULL", selected: filter.attendantId instanceof Array && filter.attendantId.find((i: any) => i === "NULL") },
                ..._attendantList,
            ];

            setAttendantList(finalOpt);
        }
        catch (e) {
            console.error(e);
        }

        setAttendantLoading(false);
    }

    const getStatus = async () => {
        try {
            const _statusList = solicitationService.statusListOptions.map((item) => {
                const _selected = (filter.idStatus instanceof Array) ? filter.idStatus.find((x: any) => x === item.value) : filter.idStatus === item.value;

                if (_selected) {
                    return {
                        ...item,
                        selected: true
                    };
                }

                return item;
            });

            setStatusList(_statusList);
        }
        catch (e) {
            console.error(e);
        }
    }

    const getGroupService = async () => {
        setGroupServiceLoading(true);

        try {
            const customer = (filter) ? filter.customerId : props.currentFilter.customerId;
            let concatenatedString = "";

            if (Array.isArray(customer) && customer.length > 0) {
                concatenatedString = customer.join("_");
            }

            const response = await serviceGroupService.GetUserAttendantFilter(user.id, concatenatedString);
            let _list = textTools.mountDropList(response.data);
            _list = refreshList(_list, filter.IdsGroupService ?? [], true);
            setGroupServiceList(_list);
        }
        catch (e) {
            console.error(e);
        }

        setGroupServiceLoading(false);
    }

    const getService = async () => {
        setServiceLoading(true)

        try {
            const customer = (filter) ? filter.customerId : props.currentFilter.customerId;
            const serviceGroup = (filter && filter.IdsGroupService) ? filter.IdsGroupService : props.currentFilter.IdsGroupService;

            let concatenatedString = "0";

            if (Array.isArray(customer) && customer.length > 0) {
                concatenatedString = customer.join("_");
            }

            let serviceGroupIds = "0";

            if (Array.isArray(serviceGroup) && serviceGroup.length > 0) {
                serviceGroupIds = serviceGroup.join("_");
            }

            let serviceResponse = await serviceService.GetByServiceGroupFilter(serviceGroupIds, concatenatedString);
            let _list = textTools.mountDropList(serviceResponse.data);
            _list = refreshList(_list, filter.IdsService ?? [], true);
            setServiceList(_list);
        }
        catch (e) {
            console.error(e);
        }

        setServiceLoading(false);
    }

    const getRequesters = async () => {
        setRequesterLoading(true);

        try {
            const customer = (filter) ? filter.customerId : props.currentFilter.customerId;
            let concatenatedString = "0";

            if (Array.isArray(customer) && customer.length > 0) {
                concatenatedString = customer.join('_');
            }

            let responseAllRequester = await userService.GetRequesters(Number(user.id), concatenatedString);
            let _list = textTools.mountDropList(responseAllRequester.data);
            _list = refreshList(_list, filter.requesterId ?? [], true);
            setRequesterList(_list);
        }
        catch (e) {
            console.debug(e);
        }

        setRequesterLoading(false);
    }

    const getState = async () => {
        try {
            let updatedTipoDataList = refreshList(solicitationService.tipoDataList, filter.TipoData ?? [], true);

            if (filter.TipoData.length === 0) {
                updatedTipoDataList = updatedTipoDataList.map((item) => {
                    if (item.value === "0") {
                        return { ...item, selected: true };
                    }

                    return item;
                });
            }

            setStateList(updatedTipoDataList);
        }
        catch (e) {
            console.debug(e);
        }
    }

    const setNotification = (message: string, severity: AlertColor, timed?: boolean) => {
        setMessageNotification(message);
        setSeverityMessage(severity);
        setOnNotification(true);

        if (timed) {
            setTimeout(() => setOnNotification(false), 3000);
        }
    }

    const submitFilter = () => {
        if (validateRules() === false) {
            return true;
        }

        setLoadingSaveFilter(true);

        let operation = (filterSelected) ? "update" : "insert";
        handleSelectedFilter(filter, nameFilter, operation);
        setOpenNameFilter(false);
        setNotification("Filtro salvo com sucesso!", "success", true);
        getFilters();

        setLoadingSaveFilter(false);
    }

    return (
        <div className='divFilter'>
            <AlertNotification
                open={onNotification}
                severity={severityMessage}
                message={messageNotifications}
                handleClose={() => setOnNotification(false)} />

            <div className={"divOrderFilterGroup"}>
                {
                    enableAttendentType &&
                    <div className={"divOrderFields"}>
                        <div style={{ width: widthGeral }}>
                            <pre>{"Perfil"}</pre>
                            <PPMultiSelect
                                openTrigger='click'
                                options={profileList}
                                onChange={(event) => onHandleChange(event, (filter && filter.attendantType) ?? [])}
                                name={"attendantType"}
                                placeholder={"Selecione o tipo"}
                                placeholderSearch={'Buscar por tipo'}
                                hideFilter
                                hideOptions
                            />
                        </div>
                    </div>
                }
                <div className={"divOrderFields"}>
                    <div style={{ width: widthGeral }}>
                        <pre>{"Cliente"}</pre>
                        <LcLoading loading={customerLoading} width={"auto"} height={"40px"} padding={"0px"}>
                            <PPMultiSelect
                                openTrigger='click'
                                options={customerList}
                                onChange={(event) => onHandleChange(event, (filter && filter.customerId) ?? [])}
                                name={"customerId"}
                                placeholder={'Selecione o cliente'}
                                placeholderSearch={'Buscar por cliente'}
                            />
                        </LcLoading>
                    </div>
                </div>

                <div className={"divOrderFields"}>
                    <div style={{ width: widthGeral }}>
                        <pre>{"Equipe"}</pre>
                        <LcLoading loading={teamLoading} width={"auto"} height={"40px"} padding={"0px"}>
                            <PPMultiSelect
                                openTrigger='click'
                                options={teamList}
                                onChange={(event) => onHandleChange(event, (filter && filter.idTeam) ?? [])}
                                name={"idTeam"}
                                placeholder={'Selecione a equipe'}
                                placeholderSearch={'Buscar por equipe'}
                                hideOptions
                            />
                        </LcLoading>
                    </div>
                </div>

                <div className={"divOrderFields"}>
                    <div style={{ width: widthGeral }}>
                        <pre>{"Atendente"}</pre>
                        <LcLoading loading={attendantLoading} width={"auto"} height={"40px"} padding={"0px"}>
                            <PPMultiSelect
                                openTrigger={"click"}
                                options={attendantList}
                                onChange={(event) => onHandleChange(event, (filter && filter.attendantId) ?? [])}
                                name={"attendantId"}
                                placeholder={"Selecione o atendente"}
                                placeholderSearch={"Buscar por atendente"}
                            />
                        </LcLoading>
                    </div>
                </div>

                <div className={"divOrderFields"}>
                    <div style={{ width: widthGeral }}>
                        <pre>{"Situação"}</pre>
                        <PPMultiSelect
                            openTrigger='click'
                            options={statusList}
                            onChange={(event) => onHandleChange(event, (filter && filter.idStatus) ?? [])}
                            name={"idStatus"}
                            placeholder={'Selecione a situação'}
                            placeholderSearch={'Buscar por situação'}
                        />
                    </div>
                </div>

                <div className={"divOrderFields"}>
                    <div style={{ width: widthGeral }}>
                        <pre>{"Grupo de serviço"}</pre>
                        <LcLoading loading={groupServiceLoading} width={"auto"} height={"40px"} padding={"0px"}>
                            <PPMultiSelect
                                openTrigger='click'
                                options={groupServiceList}
                                onChange={(event) => onHandleChange(event, (filter && filter.IdsGroupService) ?? [])}
                                name={"IdsGroupService"}
                                placeholder={"Selecione o grupo de serviço"}
                                placeholderSearch={'Buscar por grupo de serviço'}
                                hideOptions={groupServiceList.length <= 1}
                            />
                        </LcLoading>
                    </div>
                </div>

                <div className={"divOrderFields"}>
                    <div style={{ width: widthGeral }}>
                        <pre>{"Serviço"}</pre>
                        <LcLoading loading={serviceLoading} width={"auto"} height={"40px"} padding={"0px"}>
                            <PPMultiSelect
                                openTrigger='click'
                                options={serviceList}
                                onChange={(event) => onHandleChange(event, (filter && filter.IdsService) ?? [])}
                                name={"IdsService"}
                                placeholder={"Selecione o serviço"}
                                placeholderSearch={'Buscar por serviço'}
                                hideOptions
                            />
                        </LcLoading>
                    </div>
                </div>

                <div className={"divOrderFields"}>
                    <div style={{ width: widthGeral }}>
                        <pre>{"Solicitante"}</pre>
                        <LcLoading loading={requesterLoading} width={"auto"} height={"40px"} padding={"0px"}>
                            <PPMultiSelect
                                openTrigger={'click'}
                                options={requesterList}
                                onChange={(event) => onHandleChange(event, (filter && filter.requesterId) ?? [])}
                                name={"requesterId"}
                                placeholder={'Selecione o solicitante'}
                                placeholderSearch={'Buscar por solicitante'}
                                hideOptions
                            />
                        </LcLoading>
                    </div>
                </div>

                <div
                    className={"rowDate"}
                    style={{
                        // width: (menu.toggle && enableAttendentType) ? '75.3%' : '87.5%',
                        // justifyContent: (!enableAttendentType) ? 'space-between' : '',
                        // marginRight: "10px"
                    }}
                >
                    <div className={"divOrderFields"}>
                        <div style={{ width: widthGeral }}>
                            <pre>{"Período"}</pre>
                            <PPMultiSelect
                                openTrigger='click'
                                options={stateList}
                                // onChange={onHandleChange}
                                onChange={(event) => onHandleChange(event, (filter && filter.TipoData) ?? [])}
                                name={"TipoData"}
                                placeholder={"Selecione o período"}
                                placeholderSearch={'Buscar por período'}
                            />
                        </div>
                    </div>

                    <div className={"divOrderFields"}>
                        <div className={"divOrderStateDateField"}>

                            <div className={"divOrderInputStateDateField"} style={{ width: widthGeral }}>
                                <pre>{"Data inicial"}</pre>
                                {/* <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={locale}>
                                    <DatePicker
                                        defaultValue={moment(new Date())}
                                        value={moment((filter && filter.dataInicio && filter.dataInicio !== "0") ? filter.dataInicio : new Date())}
                                        onChange={(value) => onHandleChangeDate("dataInicio", value)}
                                        views={['year', 'month', 'day']}
                                        name={"dataInicio"}
                                        maxDate={moment((filter && filter.dataFinal && filter.dataFinal !== "0") ? filter.dataFinal : new Date())}
                                        slotProps={{
                                            popper: {
                                                placement: 'right-start',
                                            }
                                        }}
                                    />
                                </LocalizationProvider> */}

                                <PPInput
                                    type={"date"}
                                    placeholder={"dd/mm/aaaa"}
                                    width={widthGeral}
                                    name={"dataInicio"}
                                    value={moment((filter && filter.dataInicio && filter.dataInicio !== "0") ? filter.dataInicio : "").format("YYYY-MM-DD")}
                                    // value={moment((filter && filter.dataInicio) ?? "").format("YYYY-MM-DD")}
                                    onChange={onHandleChangeDate}
                                    max={moment((filter && filter.dataFinal && filter.dataFinal !== "0") ? filter.dataFinal : new Date()).format("YYYY-MM-DD")}
                                    style={{ color: (filter === undefined || filter.dataInicio === "0" || filter.dataInicio === "") ? "#bbb" : "black", fontSize: "12px" }}
                                // defaultValue={moment(new Date()).format("DD/MM/YYYY")}
                                />
                            </div>

                            <div className={"divOrderInputStateDateField"} style={{ width: widthGeral }}>
                                <pre>{"Data final"}</pre>
                                <PPInput
                                    type={"date"}
                                    placeholder={"dd/mm/aaaa"}
                                    // placeholder={moment(new Date()).format("DD/MM/YYYY")}
                                    width={widthGeral}
                                    name={"dataFinal"}
                                    value={moment((filter && filter.dataFinal && filter.dataFinal !== "0") ? filter.dataFinal : "").format("YYYY-MM-DD")}
                                    onChange={onHandleChangeDate}
                                    min={moment((filter && filter.dataInicio && filter.dataInicio !== "0") ? filter.dataInicio : new Date()).format("YYYY-MM-DD")}
                                    style={{ color: (filter === undefined || filter.dataFinal === "0" || filter.dataFinal === "") ? "#bbb" : "black", fontSize: "12px" }}
                                // defaultValue={moment(new Date()).format("DD/MM/YYYY")}
                                />

                                {/* <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={locale}>
                                    <DatePicker
                                        defaultValue={moment(new Date())}
                                        value={moment((filter && filter.dataFinal && filter.dataFinal !== "0") ? filter.dataFinal : new Date())}
                                        onChange={(value) => onHandleChangeDate("dataFinal", value)}
                                        views={['year', 'month', 'day']}
                                        minDate={moment((filter && filter.dataInicio && filter.dataInicio !== "0") ? filter.dataInicio : new Date())}
                                        name={"dataFinal"}
                                        slotProps={{
                                            popper: {
                                                placement: 'right-start',
                                            }
                                        }}
                                    />
                                </LocalizationProvider> */}
                            </div>

                        </div>
                    </div>

                </div>

                <div className={"divOrderFields"}
                    style={{
                        display: 'flex',
                        marginTop: '20px'
                    }}>
                    <PPToggle
                        name={"form"}
                        title={"Formulário dinâmico"}
                        toggled={filter.form || false}
                        onChange={onHandleChangeInput}
                    />
                </div>

                <div className={"divOrderSmallFields"} style={{ padding: '18px 10px' }}>
                    <button className={"lc-button bg-info"} onClick={() => applyFilters()}>Aplicar</button>
                    <button className={"lc-button bg-info"} style={{ margin: '5px' }} onClick={() => clearFilters()}>Limpar</button>

                    <LcIcon icon={"ppi ppi-divider-vertical"} color={"#CCCCCF"} />

                    <LcDropDown element={<LcIconLink icon={"ppi ppi-folder-open"} tooltip={"Mais filtros"} />} position={"Left"}>
                        <>
                            {
                                (filtersList.length === 0)
                                    ? <span className={"item"}> Sem filtros salvos </span>
                                    : <>
                                        {
                                            filtersList
                                                .slice(0, 7)
                                                .map((filter: any) => {
                                                    return (
                                                        <span className={"item"} onClick={() => handleSelectedFilter(filter, filter.name, "select")}>{filter.name}</span>
                                                    )
                                                })
                                        }
                                        <hr />
                                        <span className={"item"} onClick={() => setOpenModalFilter(true)}>Mais Filtros</span>
                                    </>
                            }
                        </>
                    </LcDropDown>

                    <LcIconLink icon={"ppi ppi-save"} onClick={() => setOpenNameFilter(!openNameFilter)} tooltip={"Salvar filtros"} tooltipPosition={'left'} />
                </div>

            </div>

            <Modal title={"Salvar filtro"} visible={openNameFilter} close={() => handleCloseModal()}>
                <LcLoading loading={loadingSaveFilter}>
                    <PPTextField
                        required
                        onChange={(e) => setNameFilter(e.target.value)}
                        value={nameFilter}
                        name={'name'}
                        label={'Nome do filtro'}
                        autoComplete="false"
                        help={validations.find(x => 'name' === x.name)?.validateMessage}
                        error={validations.find(x => 'name' === x.name) !== undefined}
                    />

                    <div className={"row"}>
                        <button
                            style={{ margin: '10px' }}
                            className={'lc-button bg-info'}
                            id={'Ok'}
                            disabled={(nameFilter && nameFilter.length > 0) ? false : true}
                            onClick={() => submitFilter()}
                            color={"primary"}>
                            Salvar
                        </button>
                        <button
                            style={{ margin: '10px' }}
                            className={'lc-button bg-info'}
                            id={'Cancelar'}
                            onClick={() => setOpenNameFilter(false)}
                            color={"primary"}>
                            Cancelar
                        </button>
                    </div>
                </LcLoading>
            </Modal>

            <SideModal header={"Seus filtros"}
                visible={openModalFilter}
                onClose={() => setOpenModalFilter(false)}
            >
                <LcLoading loading={loadingFilters} label={"Carregando..."}>
                    <LcInfiniteTable
                        // height={"calc(100% - 250px)"}
                        loading={loadingFilters}
                        columns={filterColumns}
                        rows={filtersList}
                        size={filtersList.length}
                        loadMore={() => { }}
                    // onSortChange={onSortChange}
                    />
                </LcLoading>
            </SideModal>
        </div>
    );
};

export default AttendanceFilters;